import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';

import { IHC_ANTIBODIES_BASE_URL } from 'constants/urls';

// Real anchors to antibody pages. The interactive catalog renders its rows as grid cells
// that navigate with history.push, so this is what a crawler can actually follow.
export const AntibodyLinkList = ({ antibodies }) => (
  <Box
    component="ul"
    sx={{
      listStyle: 'none',
      m: 0,
      p: 0,
      display: 'grid',
      gap: 1.5,
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    }}
  >
    {antibodies.map(({ uuid, name, catalog_number: catalogNumber }) => (
      <Box component="li" key={uuid}>
        <Link
          component={RouterLink}
          to={`${IHC_ANTIBODIES_BASE_URL}${uuid}`}
          sx={{ display: 'block', lineHeight: 1.4 }}
        >
          {name}
        </Link>
        {!!catalogNumber && (
          <Typography variant="caption" color="text.secondary">
            {catalogNumber}
          </Typography>
        )}
      </Box>
    ))}
  </Box>
);
